import { render, staticRenderFns } from "./PersonCopyMailTemplate.vue?vue&type=template&id=1d67698e&scoped=true&"
import script from "./PersonCopyMailTemplate.vue?vue&type=script&lang=js&"
export * from "./PersonCopyMailTemplate.vue?vue&type=script&lang=js&"
import style0 from "./PersonCopyMailTemplate.vue?vue&type=style&index=0&id=1d67698e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d67698e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCol,VCombobox,VDialog,VForm,VRow,VSpacer,VTextField})
